import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { YOCARE_FIREBASE_CONFIG } from 'src/config';

const app = initializeApp(YOCARE_FIREBASE_CONFIG);
const db = getFirestore(app);

export { app, db };
